 import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { toGel } from "../config/currency";
import { FaBuilding, FaSearch, FaMapMarkerAlt,  FaDollarSign, FaTag } from "react-icons/fa";



const FILTER_ICONS = {
  type: FaBuilding,            // better semantic grouping (category/type feels like tagging)
  purpose: FaTag,      // search = intent (for sale / rent)
  location: FaMapMarkerAlt,
  price: FaDollarSign,
};


const TypeIcon = FILTER_ICONS.type;
const PurposeIcon = FILTER_ICONS.purpose;
const LocationIcon = FILTER_ICONS.location;
const PriceIcon = FILTER_ICONS.price;


const TYPE_FILTER_CAPS = {
  apartment: {
    condition: true,
    renovation: true,
    building: true,
    floor: true,
    room: true,
    bedroom: true,
    project: true,
    area: true,
  },

  house: {
    condition: true,
    renovation: true,
    building: true,
    floor: false,
    room: true,
    bedroom: true,
    project: true,
    area: true,
  },

  country_house: {
    condition: true,
    renovation: true,
    building: true,
    floor: false,
    room: true,
    bedroom: true,
    project: true,
    area: true,
  },

  land: {
    condition: false,   // ❌ no black / white frame
    renovation: false,
    building: false,
    floor: false,
    room: false,
    bedroom: false,
    project: false,
    area: true,
  },

  commercial_space: {
    condition: true,
    renovation: true,
    building: true,
    floor: true,
    room: false,
    bedroom: false,
    project: true,
    area: true,
  },

  hotel: {
    condition: true,
    renovation: true,
    building: true,
    floor: true,
    room: true,
    bedroom: true,
    project: true,
    area: true,
  },
};

export default function FilterBar({
  onApply,
  displayCurrency,
  setDisplayCurrency,
  propertyType,
  setPropertyType,
}) {

  const { t } = useTranslation();

 const [openType, setOpenType] = useState(false);
  const [openSubFilter, setOpenSubFilter] = useState(false);

const [selectedAmenities, setSelectedAmenities] = useState([]);

const [openPurpose, setOpenPurpose] = useState(false);

  const [subTypes, setSubTypes] = useState([]);

const [openForForeign, setOpenForForeign] = useState(false);
const [openForAgents, setOpenForAgents] = useState(false);
const [exchangePossible, setExchangePossible] = useState(false);
const [bankPayment, setBankPayment] = useState(false);
const [priceNegotiable, setPriceNegotiable] = useState(false);

  const [conditions, setConditions] = useState([]);
  const [renovations, setRenovations] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [bedrooms, setBedrooms] = useState([]);
  const [projects, setProjects] = useState([]);

const [areaFrom, setAreaFrom] = useState("");
const [areaTo, setAreaTo] = useState("");
const [floorFrom, setFloorFrom] = useState("");
const [floorTo, setFloorTo] = useState("");
const [notFirstFloor, setNotFirstFloor] = useState(false);
const [notLastFloor, setNotLastFloor] = useState(false);


const allows = (key) => TYPE_FILTER_CAPS[propertyType]?.[key];

const [activeCity, setActiveCity] = useState("tbilisi");

  const typeRef = useRef(null);
const subFilterRef = useRef(null);
const purposeRef = useRef(null);
const priceRef = useRef(null);
const locationRef = useRef(null);

  const apartmentTypes = ["studio", "penthouse","micro","condominium","basement","mansard","other"];
  const houseTypes = ["villa", "cottage", "detached","townhouse", "contemporary", "condo", "other"];
  const landTypes = ["agricultural","non-agricultural","commercial","special","investment","farm", "other"];
  const country_houseTypes = ["villa", "cottage", "detached","townhouse", "contemporary", "condo", "other"];
  const commercial_space = ["special", "office", "trade","warehousing", "manufacturing", "food_object", "garage", "basement", "part_basement", "full_building","car_wash", "autoservice", "universal", "other"];
  const hotelTypes = ["resort","spa_hotel","suite_hotel", "bed_and_breakfast","boutique_hotel","motel", "hostel", "extended_stay", "other"];

  const conditionTypes = [
    "black_frame",
    "white_frame",
    "green_frame",
  ];

    const renovationTypes = [
    "renovation_new","renovation_old","renovation_in_process",
   ];
   
    const buildingTypes = [
    "building_new","building_old","building_under_construction",
  ];

  const roomTypes = [
    "1","2","3", "4", "5",  "6","7","8", "9", "10",  "10+",
  ];

  const bedroomTypes = [
    "1","2","3", "4", "5",  "6","7","8", "9", "10",  "10+",
  ];  

  const projectTypes = [
    "project_type_nonstandard", "project_type_tukhareli", "project_type_italian_courtyard", "project_type_leningrad", "project_type_moscow", "project_type_lvov", "project_type_city", "project_type_kavlashvili", "project_type_czech", "project_type_khrushov", "project_type_dormitory", "project_type_duplex", "project_type_triplex",
  ];




  /* PURPOSE */
  const [purpose, setPurpose] = useState("");

  /* LOCATION */
  const [openLocation, setOpenLocation] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [openCity, setOpenCity] = useState("tbilisi");
  const locationsByCity = {
  // ───── TBILISI ─────

   tbilisi: {
      vakesaburtalo: [
      "vake",
      "bagebi",
      "agaraki",
      "turtle_lake",
      "tkhinvala",
      "didi_digomi",
      "vashlijvari",
      "lisi",
      "saburtalo",
      "koshigora",
      "patara_digomi",
      "sop_digomi",
      "dighmis_tchala",
      "didgori",
    ],

    didubechughureti: [
      "ivertubani",
      "kukia",
      "svanetisubani",
      "chughureti",
      "didube",
      "digmis_masivi",
      "arsenali",
    ],

    isanisamgori: [
      "vazisubani",
      "isani",
      "metromsheni",
      "navtlughi",
      "ponitchala",
      "airport_sett",
      "aprika",
      "varketili",
      "dampalo",
      "moscow_ave",
      "samgori",
      "3rd_masivi"
    ],

      gldaninadzaladevi: [
      "avtchala",
      "gldanula",
      "gldani",
      "sop_gldani",
      "temka",
      "koniaki_sett",
      "tbilisi_sea",
      "mukhiani",
      "zahesi",
      "zgvisubani",
      "lotkini",
      "avshniani",
      "nadzaladevi",
      "grmaghele",
      "giorgitsminda_sett",
    ],

    oldTbilisi: [
      "abanotubani","avlabari","vera","elia","mtatsminda","ortatchala",
      "metekhi","rike","sololaki","krtsanisi","kharpukhi","tsavkisi_valley"
    ],
    suburbsOfTbilisi: [
      "aakhaldaba","betania","tsveri","kiketi","kojori","kaklebi",
      "okrokana","tabakhmela","shindisi","tsavkisi","tskneti","tsodoreti",
      "kveseti","upper_lisi","mskhaldidi"
    ]
   },

    batumi: {
  // ───── BATUMI ─────
     bt_kakhabris_ubani: [
      "bt_kakhabris_ubani",
    ],

       bt_tamaris_dasakhleba: [
      "bt_tamaris_dasakhleba",
    ],
     
     bt_boni_gorodski: [
      "bt_boni_gorodski",
    ],

      bt_makhinjauri: [
      "bt_makhinjauri",
    ],

      bt_dzveli_batumi: [
      "bt_dzveli_batumi",
    ],

      bt_rustaveli: [
      "bt_rustaveli",
    ],

     bt_bagrationi: [
      "bt_bagrationi",
    ],

     bt_aghmasheneb: [
      "bt_aghmasheneb",
    ],

     bt_javakhishvili: [
      "bt_javakhishvili",
    ],

     bt_khimshiashvili: [
      "bt_khimshiashvili",
    ],

     bt_aeroport: [
      "bt_aeroport",
    ]
   },

     kutaisi: {
       kt_bzholebi: ["kt_bzholebi",],
      
       kt_mtsvanekhvavila: ["kt_mtsvanekhvavila",],

       kt_balakhvani: ["kt_balakhvani",],
      
       kt_ninoshvili: ["kt_ninoshvili",],

       kt_avtoqarkhana: ["kt_avtoqarkhana",],

       kt_shaomiani: ["kt_shaomiani",],

       kt_steklotara: ["kt_steklotara",],

       kt_aghmashenebeli: ["kt_aghmashenebeli",],

       kt_nikea: ["kt_nikea",],

       kt_mepetubani: ["kt_mepetubani",],

       kt_pasiloki: ["kt_pasiloki",],

       kt_asatiani: ["kt_asatiani",],

       kt_gora: ["kt_gora",],

       kt_sapichkhia: ["kt_sapichkhia",],

       kt_saghoria: ["kt_saghoria",],

       kt_avangardi: ["kt_avangardi",],

       kt_choma: ["kt_choma",],

       kt_zastava: ["kt_zastava",],

       kt_chavchavadze: ["kt_chavchavadze",],

       kt_plashadka: ["kt_plashadka",],
    },
        rustavi: {
       __city: ["rustavi"],
    },
        zugdidi: {
       __city: ["zugdidi"],
    },
     telavi: {
       __city: ["telavi"],
    },
     gori: {
       __city: ["gori"],
    },
     bakuriani: {
       __city: ["bakuriani"],
    },
     borjomi: {
       __city: ["borjomi"],
    },
    gudauri: {
       __city: ["gudauri"],
    },

Abasha: {
  __city: ["abasha"],
},

Ambrolauri: {
  __city: ["ambrolauri"],
},

Abkhazia: {
  __city: ["abkhazia"],
},

Akhaldaba: {
  __city: ["akhaldaba"],
},

Akhaltsikhe: {
  __city: ["akhaltsikhe"],
},

Akhmeta: {
  __city: ["akhmeta"],
},

ambrolauri_municipality: {
  __city: ["ambrolauri_municipality"],
},

adigeni_municipality: {
  __city: ["adigeni_municipality"],
},

akhaltsikhe_municipality: {
  __city: ["akhaltsikhe_municipality"],
},

akhalgori_municipality: {
  __city: ["akhalgori_municipality"],
},

akhalkalaki_municipality: {
  __city: ["akhalkalaki_municipality"],
},

akhmeta_municipality: {
  __city: ["akhmeta_municipality"],
},

aspindza_municipality: {
  __city: ["aspindza_municipality"],
},

/* ───── B ───── */
  bagdadi: { __city: ["bagdadi"] },
  bolnisi: { __city: ["bolnisi"] },
  baghdati_municipality: { __city: ["baghdati_municipality"] },
  bolnisi_municipality: { __city: ["bolnisi_municipality"] },
  borjomi_municipality: { __city: ["borjomi_municipality"] },

  /* ───── C ───── */
  ckhinvali: { __city: ["ckhinvali"] },
  chiatura: { __city: ["chiatura"] },
  chokhatauri_municipality: { __city: ["chokhatauri_municipality"] },
  chkhorotsku_municipality: { __city: ["chkhorotsku_municipality"] },

  /* ───── D ───── */
  dmanisi: { __city: ["dmanisi"] },
  dedoplistskaro: { __city: ["dedoplistskaro"] },
  dusheti: { __city: ["dusheti"] },
  dedoplistskaro_municipality: { __city: ["dedoplistskaro_municipality"] },
  dusheti_municipality: { __city: ["dusheti_municipality"] },
  dmanisi_municipality: { __city: ["dmanisi_municipality"] },

  /* ───── F ───── */
  foti: { __city: ["foti"] },

  /* ───── G ───── */
  gardabani: { __city: ["gardabani"] },
  gurjaani: { __city: ["gurjaani"] },
  gardabani_municipality: { __city: ["gardabani_municipality"] },
  gori_municipality: { __city: ["gori_municipality"] },
  gurjaani_municipality: { __city: ["gurjaani_municipality"] },

  /* ───── J ───── */
  java: { __city: ["java"] },

  /* ───── K ───── */
  kaspi: { __city: ["kaspi"] },
  kareli: { __city: ["kareli"] },
  kobuleti: { __city: ["kobuleti"] },
  kazbegi: { __city: ["kazbegi"] },
  kvareli: { __city: ["kvareli"] },
  khashuri: { __city: ["khashuri"] },
  khevsureti: { __city: ["khevsureti"] },
  khelvachauri: { __city: ["khelvachauri"] },
  khobi: { __city: ["khobi"] },
  khoni: { __city: ["khoni"] },

  khoni_municipality: { __city: ["khoni_municipality"] },
  khulo_municipality: { __city: ["khulo_municipality"] },
  khashuri_municipality: { __city: ["khashuri_municipality"] },
  khelvachauri_municipality: { __city: ["khelvachauri_municipality"] },
  khobi_municipality: { __city: ["khobi_municipality"] },
  kutaisi_municipality: { __city: ["kutaisi_municipality"] },
  kareli_municipality: { __city: ["kareli_municipality"] },
  kaspi_municipality: { __city: ["kaspi_municipality"] },
  kobuleti_municipality: { __city: ["kobuleti_municipality"] },
  kazbegi_municipality: { __city: ["kazbegi_municipality"] },
  kvareli_municipality: { __city: ["kvareli_municipality"] },
  kharagauli_municipality: { __city: ["kharagauli_municipality"] },
  keda_municipality: { __city: ["keda_municipality"] },

  /* ───── L ───── */
  lagodekhi: { __city: ["lagodekhi"] },
  lanchkhuti: { __city: ["lanchkhuti"] },
  lentekhi_municipality: { __city: ["lentekhi_municipality"] },
  lanchkhuti_municipality: { __city: ["lanchkhuti_municipality"] },
  lagodekhi_municipality: { __city: ["lagodekhi_municipality"] },

  /* ───── M ───── */
  manglisi: { __city: ["manglisi"] },
  marneuli: { __city: ["marneuli"] },
  martvili: { __city: ["martvili"] },
  mestia: { __city: ["mestia"] },
  mtskheta: { __city: ["mtskheta"] },

  mtskheta_municipality: { __city: ["mtskheta_municipality"] },
  mestia_municipality: { __city: ["mestia_municipality"] },
  martvili_municipality: { __city: ["martvili_municipality"] },
  abashi_municipality: { __city: ["abashi_municipality"] },
  marneuli_municipality: { __city: ["marneuli_municipality"] },

  /* ───── N ───── */
  ninotsminda: { __city: ["ninotsminda"] },
  ninotsminda_municipality: { __city: ["ninotsminda_municipality"] },

  /* ───── O ───── */
  oni: { __city: ["oni"] },
  oni_municipality: { __city: ["oni_municipality"] },
  ozurgeti: { __city: ["ozurgeti"] },
  ozurgeti_municipality: { __city: ["ozurgeti_municipality"] },

  /* ───── S ───── */
  sachkhere: { __city: ["sachkhere"] },
  senaki: { __city: ["senaki"] },
  sagarejo: { __city: ["sagarejo"] },
  samtredia: { __city: ["samtredia"] },
  signagi: { __city: ["signagi"] },

  sachkhere_municipality: { __city: ["sachkhere_municipality"] },
  senaki_municipality: { __city: ["senaki_municipality"] },
  sagarejo_municipality: { __city: ["sagarejo_municipality"] },
  sighnaghi_municipality: { __city: ["sighnaghi_municipality"] },
  shuakhevi_municipality: { __city: ["shuakhevi_municipality"] },
  samtredia_municipality: { __city: ["samtredia_municipality"] },

  /* ───── T ───── */
  tskhinvali_district: { __city: ["tskhinvali_district"] },
  tetritskaro: { __city: ["tetritskaro"] },
  terjola: { __city: ["terjola"] },
  tkibuli: { __city: ["tkibuli"] },
  tsageri: { __city: ["tsageri"] },
  tsalenjikha: { __city: ["tsalenjikha"] },
  tsalka: { __city: ["tsalka"] },
  tsnori: { __city: ["tsnori"] },
  tskaltubo: { __city: ["tskaltubo"] },

  tkibuli_municipality: { __city: ["tkibuli_municipality"] },
  terjola_municipality: { __city: ["terjola_municipality"] },
  tetritskaro_municipality: { __city: ["tetritskaro_municipality"] },
  telavi_municipality: { __city: ["telavi_municipality"] },
  tsalka_municipality: { __city: ["tsalka_municipality"] },
  tsalenjikha_municipality: { __city: ["tsalenjikha_municipality"] },
  tsageri_municipality: { __city: ["tsageri_municipality"] },
  tskaltubo_municipality: { __city: ["tskaltubo_municipality"] },
  tianeti_municipality: { __city: ["tianeti_municipality"] },

  /* ───── V ───── */
  vani: { __city: ["vani"] },
  vale: { __city: ["vale"] },
  vani_municipality: { __city: ["vani_municipality"] },

  /* ───── Z ───── */
  zestaphoni: { __city: ["zestaphoni"] },
  zugdidi_municipality: { __city: ["zugdidi_municipality"] },
  zestaphoni_municipality: { __city: ["zestaphoni_municipality"] },
};



const getAllCityLocations = (cityKey) => {
  const cityData = locationsByCity[cityKey];
  if (!cityData) return [];
  return Object.values(cityData).flat();
};

const isFullCitySelected = (cityKey) => {
  const all = getAllCityLocations(cityKey);
  return all.length > 0 && all.every(l => selectedLocations.includes(l));
};



  const handleLocationChange = (loc) => {
    setSelectedLocations((prev) => (prev.includes(loc) ? prev.filter((x) => x !== loc) : [...prev, loc]));
  };

  const handleGroupToggle = (groupKey) => {
  const group = locationsByCity[openCity][groupKey] || [];
  const allSelected = group.every((l) => selectedLocations.includes(l));

  setSelectedLocations((prev) =>
    allSelected
      ? prev.filter((l) => !group.includes(l))
      : [...new Set([...prev, ...group])]
  );
};


const getSubTypeList = () => {
    switch (propertyType) {
      case "apartment": return apartmentTypes;
      case "house": return houseTypes;
      case "country_house": return country_houseTypes;
      case "land": return landTypes;
      case "commercial_space": return commercial_space;
      case "hotel": return hotelTypes;
      default: return [];
    }
  };


 const toggle = (setter, value) => {
    setter(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };


/* TYPE + SUBFILTERS */
const getConditionTypeList = () => conditionTypes;
const getRenovationTypeList = () => renovationTypes;
const getBuildingTypeList = () => buildingTypes;
const getRoomTypeList = () => roomTypes;
const getBedroomTypeList = () => bedroomTypes;
const getProjectTypeList = () => projectTypes;


useEffect(() => {
  const caps = TYPE_FILTER_CAPS[propertyType] || {};

  if (!caps.condition) setConditions([]);
  if (!caps.renovation) setRenovations([]);
  if (!caps.building) setBuildings([]);
  if (!caps.room) setRooms([]);
  if (!caps.bedroom) setBedrooms([]);
  if (!caps.project) setProjects([]);

if (!caps.area) {
    setAreaFrom("");
    setAreaTo("");

if (!caps.floor) {
  setFloorFrom("");
  setFloorTo("");
  setNotFirstFloor(false);
  setNotLastFloor(false);
}

  }


  // subTypes are always type-specific → always reset
  setSubTypes([]);
}, [propertyType]);




  /* CLICK OUTSIDE */
 useEffect(() => {
  const handleClickOutside = (e) => {

    if (e.target.closest(".language-switch")) {
    return;
  }

    if (
      typeRef.current &&
      !typeRef.current.contains(e.target) &&
     (
      !subFilterRef.current ||
      !subFilterRef.current.contains(e.target)
      )
    ) {
      setOpenType(false);
      setOpenSubFilter(false);
    }

    if (
      purposeRef.current &&
      !purposeRef.current.contains(e.target)
    ) {
      setOpenPurpose(false);
    }

    if (
      locationRef.current &&
      !locationRef.current.contains(e.target)
    ) {
      setOpenLocation(false);
    }

    if (
      priceRef.current &&
      !priceRef.current.contains(e.target)
    ) {
      setOpenPrice(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);



/* PRICE */
const [openPrice, setOpenPrice] = useState(false);
const [maxPriceInput, setMaxPriceInput] = useState("");
const [maxPricePerM2Input, setMaxPricePerM2Input] = useState("");


const toggleCity = (cityKey) => {
  const cityLocations = getAllCityLocations(cityKey);

  const allSelected = cityLocations.every((loc) =>
    selectedLocations.includes(loc)
  );

  setSelectedLocations((prev) =>
    allSelected
      ? prev.filter((l) => !cityLocations.includes(l))
      : [...new Set([...prev, ...cityLocations])]
  );
};

const isCityChecked = (cityKey) =>
  getAllCityLocations(cityKey).every((loc) =>
    selectedLocations.includes(loc)
  );

const isCityIndeterminate = (cityKey) => {
  const cityLocations = getAllCityLocations(cityKey);
  const selected = cityLocations.filter((l) =>
    selectedLocations.includes(l)
  );

  return selected.length > 0 && selected.length < cityLocations.length;
};


const getDistrictLocations = (cityKey, districtKey) =>
  locationsByCity[cityKey]?.[districtKey] || [];

const toggleDistrict = (cityKey, districtKey) => {
  const districtLocations = getDistrictLocations(cityKey, districtKey);

  const allSelected = districtLocations.every((l) =>
    selectedLocations.includes(l)
  );

  setSelectedLocations((prev) =>
    allSelected
      ? prev.filter((l) => !districtLocations.includes(l))
      : [...new Set([...prev, ...districtLocations])]
  );
};

const isDistrictChecked = (cityKey, districtKey) =>
  getDistrictLocations(cityKey, districtKey).every((l) =>
    selectedLocations.includes(l)
  );

const isDistrictIndeterminate = (cityKey, districtKey) => {
  const districtLocations = getDistrictLocations(cityKey, districtKey);
  const selected = districtLocations.filter((l) =>
    selectedLocations.includes(l)
  );

  return selected.length > 0 && selected.length < districtLocations.length;
};

const showForeignFilter =
  !(
    propertyType === "land" ||
    propertyType === "house" ||
    propertyType === "country_house" ||
    propertyType === "commercial_space"
  );


  /* APPLY */
  const handleApply = () => {
  const maxPriceGel =
    maxPriceInput
      ? toGel(Number(maxPriceInput), displayCurrency)
      : null;

const maxPricePerM2Gel = maxPricePerM2Input
  ? toGel(Number(maxPricePerM2Input), displayCurrency)
  : null;

    const newFilter = {
      type: propertyType,
      subTypes,

openForForeign,
openForAgents,
exchangePossible,
bankPayment,
priceNegotiable,

      purpose,
      location: selectedLocations,
      conditions,
      renovations,
      buildings,
      projects,
      rooms,
      bedrooms,
      price: maxPriceGel,
      pricePerM2: maxPricePerM2Gel,

      areaFrom,
      areaTo,

   floorFrom,
   floorTo,
   notFirstFloor,
   notLastFloor,

    amenities: selectedAmenities,

    };
     onApply?.(newFilter);
     setOpenSubFilter(false);
};


useEffect(() => {
  if (!showForeignFilter) {
    setOpenForForeign(false);
  }
}, [propertyType, purpose]);

 return (
  
<section className="filter-hero">
  <div className="filter-container">
   <section className="filter-bar">

<div className="filter-grid">

    {/* TYPE OPTIONS */}
<div className="filter-item" ref={typeRef}>
  <button
  type="button"
  className="filter-btn filter-btn--tall"
  onClick={(e) => {
    e.stopPropagation();
    setOpenType((prev) => !prev);
    setOpenSubFilter(false);
  }}
>
  <span className="filter-btn-icon">
    <TypeIcon />
  </span>

  <span className="filter-btn-text">
    {propertyType
      ? t(`property.type.${propertyType}`)
      : t("common.type")}
  </span>
</button>

  {openType && (
    <div className="dropdown-panel">
      {[
        "apartment",
        "house",
        "country_house",
        "land",
        "commercial_space",
        "hotel",
      ].map((v) => (
        <button
          key={v}
          type="button"
          className="dropdown-option"
          onClick={() => {
            setPropertyType(v);
            setOpenType(false);
            setOpenSubFilter(true); // 🔥 open subfilters
          }}
        >
           {t(`property.type.${v}`)}
        </button>
      ))}
    </div>
  )}
</div>


{openSubFilter && (
  <div
    ref={subFilterRef}
    className="dropdown-panel subfilter-box"
    onMouseDown={(e) => e.stopPropagation()}

>
  {/* COLUMN 1 */} 

 <div className="subfilter-column">
  <div className="panel-title">{t("sub_type")}</div>

  <div className="subfilter-options">
    {getSubTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={subTypes.includes(v)}
          onChange={() => toggle(setSubTypes, v)}
        />
        <span>{t(`property.subtype.${v}`)}</span>
      </label>
    ))}
  </div>
</div>

{/* COLUMN 2 */}
 {allows("condition") && (
 <div className="subfilter-column">
  <div className="panel-title">{t("condition_type")}</div>

  <div className="subfilter-options">
    {getConditionTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={conditions.includes(v)}
          onChange={() => toggle(setConditions, v)}
        />
        <span>{t(v)}</span>
      </label>
    ))}
  </div>
</div>
)}

{/* COLUMN 3 */}
 {allows("renovation") && (
 <div className="subfilter-column">
  <div className="panel-title">{t("renovation_type")}</div>

  <div className="subfilter-options">
    {getRenovationTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={renovations.includes(v)}
      onChange={() => toggle(setRenovations, v)}
        />
        <span>{t(v)}</span>
      </label>
    ))}
  </div>
</div>
)}

{/* COLUMN 4 */}
 {allows("building") && (
 <div className="subfilter-column">
  <div className="panel-title">{t("building_type")}</div>

  <div className="subfilter-options">
    {getBuildingTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={buildings.includes(v)}
      onChange={() => toggle(setBuildings, v)}
        />
        <span>{t(v)}</span>
      </label>
    ))}
  </div>
</div>
)}

{/* COLUMN 5 */}
{allows("floor") && (
  <div className="subfilter-column">
    <div className="panel-title">{t("floor")}</div>

    <div className="area-range">
      <input
        type="number"
        min="0"
        placeholder={t("from")}
        value={floorFrom}
        onChange={(e) => setFloorFrom(e.target.value)}
      />

      <span>–</span>

      <input
        type="number"
        min="0"
        placeholder={t("to")}
        value={floorTo}
        onChange={(e) => setFloorTo(e.target.value)}
      />
    </div>

    <label className="subfilter-option">
      <input
        type="checkbox"
        checked={notFirstFloor}
        onChange={() => setNotFirstFloor(p => !p)}
      />
      <span>{t("flouor.not_first")}</span>
    </label>

    <label className="subfilter-option">
      <input
        type="checkbox"
        checked={notLastFloor}
        onChange={() => setNotLastFloor(p => !p)}
      />
      <span>{t("flouor.not_last")}</span>
    </label>
  </div>
)}


{/* COLUMN 6 */}
 {allows("room") && (
 <div className="subfilter-column">
  <div className="panel-title">{t("room_type")}</div>

  <div className="subfilter-options">
    {getRoomTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={rooms.includes(v)}
      onChange={() => toggle(setRooms, v)}
        />
        <span>{t(v)}</span>
      </label>
    ))}
  </div>
</div>
)}

{/* COLUMN 7 */}
 {allows("bedroom") && (
 <div className="subfilter-column">
  <div className="panel-title">{t("bedroom_type")}</div>

  <div className="subfilter-options">
    {getBedroomTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={bedrooms.includes(v)}
      onChange={() => toggle(setBedrooms, v)}
        />
        <span>{t(v)}</span>
      </label>
    ))}
  </div>
</div>
)}

{/* COLUMN 8 */}
 {allows("project") && (
 <div className="subfilter-column">
  <div className="panel-title">{t("project_type")}</div>

  <div className="subfilter-options">
    {getProjectTypeList().map((v) => (
      <label key={v} className="subfilter-option">
        <input
          type="checkbox"
          checked={projects.includes(v)}
      onChange={() => toggle(setProjects, v)}
        />
        <span>{t(v)}</span>
      </label>
    ))}
  </div>
</div>
)}

   {/* COLUMN 9 */}
      {allows("area") && (
  <div className="subfilter-column">
    <div className="panel-title">{t("area_m2")}</div>

    <div className="area-range">
      <input
        type="number"
        min="0"
        placeholder={t("froom")}
        value={areaFrom}
        onChange={(e) => setAreaFrom(e.target.value)}
      />

      <span>–</span>

      <input
        type="number"
        min="0"
        placeholder={t("too")}
        value={areaTo}
        onChange={(e) => setAreaTo(e.target.value)}
      />

    </div>
  </div>
)}

{/* COLUMN FLAGS */}
<div className="subfilter-column">

  <div className="panel-title">{t("listing_flags.title")}</div>

  {showForeignFilter && (
  <label className="switch-row">
    <span>{t("listing_flags.foreign")}</span>
    <input
      type="checkbox"
      checked={openForForeign}
      onChange={() => setOpenForForeign(p => !p)}
    />
  </label>
)}

  <label className="switch-row">
    <span>{t("listing_flags.agents")}</span>
    <input
      type="checkbox"
      checked={openForAgents}
      onChange={() => setOpenForAgents(p => !p)}
    />
  </label>

  <label className="switch-row">
    <span>{t("listing_flags.exchange")}</span>
    <input
      type="checkbox"
      checked={exchangePossible}
      onChange={() => setExchangePossible(p => !p)}
    />
  </label>

  <label className="switch-row">
    <span>{t("listing_flags.mortgage")}</span>
    <input
      type="checkbox"
      checked={bankPayment}
      onChange={() => setBankPayment(p => !p)}
    />
  </label>

  <label className="switch-row">
    <span>{t("listing_flags.negotiable")}</span>
    <input
      type="checkbox"
      checked={priceNegotiable}
      onChange={() => setPriceNegotiable(p => !p)}
    />
  </label>

</div>


          {/* APPLY */}
          <div className="subfilter-actions">
      <button
    className="save-btn"
    onClick={() => setOpenSubFilter(false)}
  >
    {t("saveFilters")}
  </button>
       </div>
          </div>
      )}


{/* PURPOSE */}
<div className="filter-item" ref={purposeRef}>
    <button
    type="button"
    className="filter-btn filter-btn--tall"
    onClick={(e) => {
      e.stopPropagation();
      setOpenPurpose((prev) => !prev);
    }}
  >
    <span className="filter-btn-icon">
      <PurposeIcon />
    </span>

    <span className="filter-btn-text">
      {purpose
        ? t(`property.purpose.${purpose}`)
        : t("common.purpose")}
    </span>
  </button>


  {openPurpose && (
    <div className="dropdown-panel">
      {["for_sale", "for_rent", "daily_rent", "for_lease", "collateral"].map((p) => (
        <button
          key={p}
          type="button"
          className="dropdown-option"
          onClick={() => {
            setPurpose(p);
            setOpenPurpose(false);
          }}
        >
          {t(`property.purpose.${p}`)}
        </button>
      ))}
    </div>
  )}
</div>


 {/* ✅ LOCATION — THIS WHOLE BLOCK STAYS TOGETHER */}
  <div className="filter-item filter-wrapper" ref={locationRef}>
      <button
    type="button"
    className="filter-btn filter-btn--tall"
    onClick={(e) => {
      e.stopPropagation();
      setOpenLocation((prev) => !prev);
    }}
  >
    <span className="filter-btn-icon">
      <LocationIcon />
    </span>

    <span className="filter-btn-text">
      {selectedLocations.length === 0
        ? t("common.location")
        : selectedLocations.length === 1
        ? t(`location.${selectedLocations[0]}`)
        : `${t(`location.${selectedLocations[0]}`)} +${selectedLocations.length - 1}`}
    </span>
  </button>


    {openLocation && (
      <div className="dropdown-panel location-panel">

        <div className="location-layout">

  {/* LEFT — DISTRICTS */}
  <div className="districts-column">
    {Object.entries(locationsByCity[activeCity] || {})
    .filter(([districtKey]) => districtKey !== "__city")
    .map(([districtKey, locations]) => (

        <div key={districtKey} className="district-group">

          <label className="district-title">
            <input
              type="checkbox"
              checked={isDistrictChecked(activeCity, districtKey)}
              ref={(el) => {
                if (el)
                  el.indeterminate = isDistrictIndeterminate(
                    activeCity,
                    districtKey
                  );
              }}
              onChange={() => toggleDistrict(activeCity, districtKey)}
            />
            {t(`location.${districtKey}`)}
          </label>

          <div className="district-items">
            {locations.map((loc) => (
              <label key={loc} className="district">
                <input
                  type="checkbox"
                  checked={selectedLocations.includes(loc)}
                  onChange={() => handleLocationChange(loc)}
                />
                {t(`location.${loc}`)}
              </label>
            ))}
          </div>

        </div>
      )
    )}
  </div>

  {/* RIGHT — CITIES */}
  <div className="cities-column">
    {Object.entries(locationsByCity).map(([city]) => (
      <label key={city} className="city-row">
        <input
          type="checkbox"
          checked={isCityChecked(city)}
          ref={(el) => {
            if (el) el.indeterminate = isCityIndeterminate(city);
          }}
          onChange={() => {
          toggleCity(city);
         setActiveCity(city);
        }}
        />
        <span
          className={city === activeCity ? "active-city" : ""}
          onClick={() => setActiveCity(city)}
        >
          {t(`location.${city}`)}
        </span>
      </label>
    ))}
  </div>

</div>
</div>   
  )}
</div> 



{/* PRICE FILTER */}
<div className="filter-item" ref={priceRef}>
    <button
    type="button"
    className="filter-btn filter-btn--tall"
    onClick={(e) => {
      e.stopPropagation();
      setOpenPrice((prev) => !prev);
    }}
  >
    <span className="filter-btn-icon">
      <PriceIcon />
    </span>

    <span className="filter-btn-text">
      {t("price")}
    </span>
  </button>

  {openPrice && (
    <div className="dropdown-panel price-panel"
    onMouseDown={(e) => e.stopPropagation()}
         >

      {/* Currency switch */}
      <div className="currency-switch">
        <button
          type="button"
          className={displayCurrency === "GEL" ? "active" : ""}
          onClick={() =>
            displayCurrency !== "GEL" && setDisplayCurrency("GEL")
          }
        >
          GEL
        </button>

        <button
          type="button"
          className={displayCurrency === "USD" ? "active" : ""}
          onClick={() =>
            displayCurrency !== "USD" && setDisplayCurrency("USD")
          }
        >
          USD
        </button>
      </div>

      {/* MAX PRICE */}
      <label className="price-label">{t("max_price")}</label>
      <input
        type="number"
        min="0"
        className="filter-input"
        value={maxPriceInput}
        onChange={(e) => setMaxPriceInput(e.target.value)}
        placeholder={t("max_price")}
      />

      {/* PRICE PER M² */}
      <label className="price-label">{t("price_per_m2")}</label>
      <input
        type="number"
        min="0"
        className="filter-input"
        value={maxPricePerM2Input}
        onChange={(e) => setMaxPricePerM2Input(e.target.value)}
        placeholder={t("price_per_m2")}
      />

    </div>
  )}
</div>

</div>


      {/* APPLY BUTTON */}
     <button className="apply-btn" onClick={handleApply}>
  <FaSearch className="apply-icon" />
  {t("apply")}
</button>
    

{(openType ||
  openPurpose ||
  openLocation ||
  openPrice ||
  openSubFilter) && (
  <div className="filter-backdrop" />
)}


      </section>
     </div>
    </section>
  );
}

